<router-outlet @fadeIn></router-outlet>
<!-- Simon iframe for logout -->
<iframe id="simonIframe" [src]="environment.simonIframeOrigin | safeUrl" class="hidden"></iframe>
